///<reference path="../../../../../typings/index.d.ts"/>
///<reference path="../short-cuts.interfaces.ts"/>
///<reference path="../short-cuts.enums.ts"/>

module Meevo.Components.ShortCuts {
    export class ShortCutGroup implements IShortCutGroup {
        public readonly id: string;
        public readonly deactivateGlobal: boolean;
        public readonly groupLevel: GroupLevels;
        public readonly scope?: ng.IScope;
        public noun: Meevo.Model.NounEnum;
        private _shortCuts: IShortCutGroupItem[];

        /**
         * @returns array of short Keys of group
         */
        public get shortCuts(): IShortCutGroupItem[] {
            return this._shortCuts;
        }

        /**
         *
         * @returns array of combination names of group
         */
        public get shortCutCombinationNames(): (keyof ICombinationNames)[] {
            return this._shortCuts.map(shortKey => shortKey.shortCutName)
        }

        constructor(groupOptions: IShortCutGroupItem[], options?: IShortCutsGroupOptions) {
            const {scope, groupLevel, deactivateGlobal, noun} = options || <IShortCutsGroupOptions>{};

            this._shortCuts = groupOptions;
            this.scope = scope;
            this.id = `${Math.ceil(Math.random() * 1000)}-${new Date().getTime()}`;
            this.groupLevel = groupLevel === undefined ? GroupLevels.Plugin : groupLevel;
            this.deactivateGlobal = deactivateGlobal === undefined ? false : deactivateGlobal;
            this.noun = noun;
        }

        /**
         * method adds short key to group
         * @param {Meevo.Components.ShortCuts.IShortCutGroupItem} shortCuts
         */
        public addShortCuts(shortCuts: IShortCutGroupItem | IShortCutGroupItem[]) {
            if (!(shortCuts instanceof Array)) {
                shortCuts = [shortCuts];
            }

            shortCuts.forEach(shortCut => {
                this._shortCuts.push({
                    ...shortCut
                })
            });
        }

        /**
         * method removes a short key from group
         * @param {item} shortKeyNames
         */
        public removeShortCuts(shortKeyNames: keyof ICombinationNames | (keyof ICombinationNames)[]) {
            if (!(shortKeyNames instanceof Array)) {
                shortKeyNames = [shortKeyNames];
            }

            shortKeyNames.forEach(shortKeyName => {
                this._shortCuts = this._shortCuts.filter(shortKey => shortKey.shortCutName !== shortKeyName);
            });
        }
    }
}
